<div
	class="btn-container"
	[ngClass]="{
		vertical: alignment === BUTTON_CONTAINER_ALIGNMENT.Vertical,
		border: showBorder,
		'spacing-sm': spacing === BUTTON_CONTAINER_SPACING.Small,
		'spacing-md': spacing === BUTTON_CONTAINER_SPACING.Medium,
		'spacing-lg': spacing === BUTTON_CONTAINER_SPACING.Large,
		left: justification === BUTTON_CONTAINER_JUSTIFICATION.Left,
		right: justification === BUTTON_CONTAINER_JUSTIFICATION.Right,
		fill: justification === BUTTON_CONTAINER_JUSTIFICATION.Fill
	}"
>
	<ng-content></ng-content>
</div>
